import React, { useEffect, useState } from 'react'
import { checkPermission, generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import EmprConfigHeaderCard from 'views/pages/manage/masters/studentFinancials/epmrConfigs/EpmrConfigHeader';
import { getDropdowns, openInNewTab } from '../../../studentRefund/common/services';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import styles from '../../paymentManagement.module.scss';
import EmptyListPlaceholder from 'views/pages/manage/masters/studentFinancials/epmrConfigs/EmptyListPlaceHolder';
import ALoader from 'views/pages/manage/common/a-loader';
import ConfigSummaryCard from './ConfigSummaryCard';
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import APopover from "views/pages/manage/common/a-popover";
import { createConfig, getConfigs, getFilterReqObj, getFormattedPaymentConfig, updateConfig, PAYMENT_CONFIG_FILTER_FORM_FIELDS } from './utils';
import { getFilterCount } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import FilterForm from './FilterForm';
import { DIGITAL_BUSINESS_IDS } from 'views/pages/manage/common/hook/useCashierOfficeDropdown'
import AddEditConfigDialog from './addEditConfigDialog/AddEditConfigDialog';
import { getBuAgainstBuTypes } from 'modules/studentRefund/refundMasters/refundsApprovalConfig/services';
import { deleteConfig } from './utils'

const PMApprovalConfigListing = ({ userPermissions }) => {
    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, 'U');
    const isDeletePermission = checkPermission(userPermissions, 'D');

    const [form, setForm] = useState(null);
    const [paymentsApprovalConfig, setPaymentsApprovalConfig] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const [filterForm, setFilterForm] = useState({ ...PAYMENT_CONFIG_FILTER_FORM_FIELDS, });
    const [buLoading, setBuLoading] = useState(false);

    const handleForm = (key, value) => setForm(prev => ({ ...prev, [key]: value }));
    const addEditConfigDialogOpen = !!form;

    const closeAddEditConfigDialog = () => {
        setForm(null);
        setDropdownData(prev => ({
            ...prev,
            businessAreas: []
        }))
    }

    const addConfigHandler = () => setForm({
        isNew: true,
        approvalSettingDTO: []
    });

    const getAllPaymentsApprovalConfig = async (dropdowns = dropdownData, filters = filterForm) => {
        try {
            setLoading(true);
            const resp = await getConfigs(getFilterReqObj(filters, dropdowns?.allActiveBu));
            const paymentConfigs = resp?.data ?? [];
            setPaymentsApprovalConfig(paymentConfigs?.map(config => getFormattedPaymentConfig(config, dropdowns)));
        } catch (e) {
            console.log(e);
        }
        finally {
            setLoading(false);
        }
    }

    const init = async () => {
        try {
            setLoading(true);
            const dropdownData = await getDropdowns();
            setDropdownData(dropdownData);
            getAllPaymentsApprovalConfig(dropdownData);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);

        }
    }

    const deleteConfigHandler = async (id) => {
        try {
            setLoading(true);

            const resp = await deleteConfig(id);
            if (resp) {
                successToast("Request completed successfully!");
                getAllPaymentsApprovalConfig();
            }

        } catch (err) {
            console.log(err);

        } finally {
            setLoading(false);
        }
    }


    const createUpdateConfigHandler = async () => {
        try {
            setLoading(true);
            const resp = await (form?.isNew ? createConfig(form) : updateConfig(form));
            if (resp?.code === 200) {
                successToast("Request completed successfully!");
                getAllPaymentsApprovalConfig();
                closeAddEditConfigDialog();
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }


    const handleFilterForm = (key, val) => setFilterForm(prev => ({ ...prev, [key]: val }));

    const removeFilterHandler = async () => {
        await getAllPaymentsApprovalConfig(dropdownData, {});
        setFilterForm({});
    }

    const applyFilterHandler = () => {
        getAllPaymentsApprovalConfig(dropdownData, filterForm);
    };

    const buTypeChangeHandler = async (selectedBranchType) => {
        try {
            handleForm("branchType", [selectedBranchType]);

            let buAgainstBranchTypes = [];
            const branchTypeValue = typeof selectedBranchType?.label === "string"
                ? selectedBranchType?.label?.toLowerCase()
                : null;

            if (branchTypeValue === "advance") {
                buAgainstBranchTypes = dropdownData?.advanceBusinessAreas ?? [];
            } else if (selectedBranchType) {
                buAgainstBranchTypes = await getBuAgainstBuTypes(selectedBranchType, setBuLoading);
                buAgainstBranchTypes = buAgainstBranchTypes?.filter(bu => !DIGITAL_BUSINESS_IDS?.includes(bu?.label))
            }

            handleForm("businessArea", []);
            setDropdownData(prev => ({
                ...prev,
                businessAreas: buAgainstBranchTypes
            }));

        } catch (err) {
            console.error(err);
        }
    };

    const editConfigHandler = async config => {
        try {
            setForm({ ...config });
            let buAgainstBranchTypes = [];

            const bt = config?.branchType;

            const branchTypeValue =
                typeof bt === "string"
                    ? bt.toLowerCase()
                    : typeof bt?.label === "string"
                        ? bt.label.toLowerCase()
                        : "";
            if (branchTypeValue === "advance") {
                buAgainstBranchTypes = dropdownData?.advanceBusinessAreas ?? [];
            } else if (config?.branchType) {
                buAgainstBranchTypes = await getBuAgainstBuTypes(config?.branchType, setBuLoading);
                buAgainstBranchTypes = buAgainstBranchTypes?.filter(bu => !DIGITAL_BUSINESS_IDS?.includes(bu?.label))
            }

            setDropdownData(prev => ({
                ...prev,
                businessAreas: buAgainstBranchTypes
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        init();
    }, [])

    return (
        <>
            {loading && <ALoader position="fixed" />}

            <EmprConfigHeaderCard
                addConfigHandler={addConfigHandler}
                isCreatePermission={isCreatePermission}
                heading='Payment management approval configs'
            />

            <div className="d-flex justify-content-between my-3 mx-3">
                <div>
                    <h4 className='className="color-black"'>{paymentsApprovalConfig?.length} Configs</h4>
                </div>
                <div className="d-flex justify-content-between">
                    {/* <AButton
                        variant="outline"
                        // onClick={() => { openInNewTab('refundSetup/paymentsApprovalConfig/logs') }}
                        size="xs"
                    >
                        Logs
                    </AButton> */}
                    <APopover
                        buttonComponent={(onClick, styles) => (
                            <AButton
                                className="tiny-semi-bold color-dark"
                                onClick={onClick}
                                variant="outline"
                                size="xs"
                                updatedStyle={{
                                    minWidth: "61px",
                                    ...(filterCount > 0
                                        ? {
                                            border: "1px solid #00B0F5",
                                            color: "#00B0F5",
                                        }
                                        : styles),
                                }}
                            >
                                Filter {filterCount > 0 && <>( {filterCount} )</>}
                            </AButton>
                        )}
                        menuComponent={(closePopup) => (
                            <FilterForm
                                closePopup={closePopup}
                                dropdownData={dropdownData}
                                filterForm={filterForm}
                                filterCount={filterCount}
                                setFilterCount={setFilterCount}
                                setFilterForm={setFilterForm}
                                applyFilterHandler={applyFilterHandler}
                                handleFilterForm={handleFilterForm}
                                removeFilterHandler={removeFilterHandler}

                            />
                        )}
                    />
                </div>
            </div>

            {paymentsApprovalConfig?.length > 0 ?
                <div className={`p-3 ${styles['config-cards-container']}`}>
                    {paymentsApprovalConfig?.map((config, index) =>
                        <ConfigSummaryCard
                            key={index}
                            config={config}
                            deleteConfigHandler={deleteConfigHandler}
                            editConfigHandler={editConfigHandler}
                            isUpdatePermission={isUpdatePermission}
                            isDeletePermission={isDeletePermission}
                        />)}
                </div>
                :
                <EmptyListPlaceholder
                    addConfigHandler={addConfigHandler}
                    isCreatePermission={isCreatePermission}
                    title='Click here to add first configuration for Payment management' />
            }

            <AddEditConfigDialog
                open={addEditConfigDialogOpen}
                handleClose={closeAddEditConfigDialog}
                form={form}
                setForm={setForm}
                handleForm={handleForm}
                dropdownData={dropdownData}
                createUpdateConfigHandler={createUpdateConfigHandler}
                buTypeChangeHandler={buTypeChangeHandler}
                buLoading={buLoading}
                loading={loading}
                setLoading={setLoading}
            />
        </>
    )
}

export default PMApprovalConfigListing;